import { Column } from '../../../../hooks/useTablePages';
import { WaterSupplierItem } from './WaterSuppliers.query';

const columns: Column[] = [
  {
    header: 'id',
    accessor: 'profileId',
    width: 100,
  },
  {
    header: 'Name',
    accessor: 'profile.name',
    width: 275,
  },
  {
    id: 'hasUser',
    header: 'Has User',
    accessor: (row: WaterSupplierItem) => {
      return row.hasUser ? 'Yes' : 'No';
    },
    width: 100,
  },
  {
    id: 'profile.phones.value',
    header: 'Phone',
    accessor: (row: WaterSupplierItem) => row.profile.phones[0]?.value,
    width: 140,
  },
  {
    id: 'profile.emails.value',
    header: 'Email',
    accessor: (row: WaterSupplierItem) => row.profile.emails[0]?.value,
    width: 300,
  },
  {
    header: 'Address',
    id: 'profile.contactAddress.street1',
    accessor: (row: WaterSupplierItem) =>
      (row.profile.contactAddress?.street1
        ? row.profile.contactAddress.street1
        : '') +
      (row.profile.contactAddress?.street2
        ? ', ' + row.profile.contactAddress.street2
        : ''),
    width: 400,
  },
  {
    header: 'City',
    accessor: 'profile.contactAddress.city',
    width: 120,
  },
  {
    header: 'State',
    accessor: 'profile.contactAddress.state',
    width: 60,
  },
  {
    header: 'Zip',
    id: 'profile.contactAddress.zip',
    accessor: (row: WaterSupplierItem) =>
      (row.profile.contactAddress?.zip ? row.profile.contactAddress.zip : '') +
      (row.profile.contactAddress?.zipExt
        ? '-' + row.profile.contactAddress.zipExt
        : ''),
    width: 120,
  },
];

export default columns;
